/* global axios */
import ApiClient from './ApiClient';

class AccountNotes extends ApiClient {
  constructor() {
    super('notes', { accountScoped: true });
  }

  get(page = 1) {
    return axios.get(this.url, { params: { page } });
  }
}

export default new AccountNotes();
